var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.show)?_c('div',{class:_vm.classes},[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('a',{attrs:{"href":"#"},on:{"click":_vm.closeToast}},[_vm._v("×")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }